<template>
  <znl-dialog
    :visible="visible"
    :append-to-body="true"
    title="阶梯价"
    width="600px"
    class="c-SelectPricing"
    @close="$emit('update:visible', false)"
  >
    <div class="c-price-card-box">
      <div
        class="c-price-card-box-scroll"
        :style="scrollBoxStyle"
      >
        <price-card
          v-for="(item, index) in tieredPricingsNative"
          :key="index"
          :price-data="item"
          :allow-edit="false"
          :class="{active: item.StepPlanGuid === activeStepPlanGuid}"
          tabindex="1"
          ref="pricecard"
          @click.native="()=>setActiveRowHandler(item)"
        >
        </price-card>
      </div>
    </div>
    <div slot="footer">
      <znl-button
        type="text"
        class="pull-left fmt"
        @click="changePricing"
      >
        修改阶梯价
      </znl-button>
      <znl-button
        :width="80"
        :height="30"
        @click="$emit('update:visible', false)"
      >
        取消
      </znl-button>
      <znl-button
        :width="80"
        :height="30"
        style-type="main"
        class="fml"
        @click="setCurrentTableRowStepPlanGuid"
      >
        确定
      </znl-button>
    </div>
  </znl-dialog>
</template>
<script>
import PriceCard from '../PricingStrategy/PriceCard';
import TradingStore from '../../store';
import { httpPost } from '../../assets/scripts/http';

export default {
  name: 'SelectPricing',
  components: {
    PriceCard
  },
  computed: {
    scrollBoxStyle() {
      const style = {};
      style.width = this.tieredPricingsNative.length * 230 + 'px';
      return style;
    }
  },
  props: {
    visible: Boolean,
    tieredPricingsNative: {
      type: Array,
      default() {
        return [];
      }
    },
    currentTableRows: {
      type: Array,
      default() {
        return [];
      }
    },
    updateRowData: Function,
    saveHandler: Function,
    Model: String,
    Brand: String,
    StandardPriceStart: String,
    StandardPriceEnd: String,
    StepPlanGuid: String,
    IsUnUsual: Boolean,
    getIsInvoice: Function
  },
  watch: {
    visible(val) {
      if (!val) {
        this.activeStepPlanGuid = '';
      } else {
        if (this.currentTableRows && this.currentTableRows.length > 0) {
          this.activeStepPlanGuid = this.currentTableRows[0].StepPlanGuid;
          this.$nextTick(() => {
            let i = 0;
            for (
              let index = 0;
              index < this.tieredPricingsNative.length;
              index++
            ) {
              if (
                this.tieredPricingsNative[index].StepPlanGuid ===
                this.currentTableRows[0].StepPlanGuid
              ) {
                i = index;
                break;
              }
            }
            this.$refs.pricecard[i].$el.focus();
          });
        }
      }
    }
  },
  data() {
    return {
      activeStepPlanGuid: '',
      store: TradingStore
    };
  },
  methods: {
    setActiveRowHandler(item) {
      this.activeStepPlanGuid = item.StepPlanGuid;
    },
    setCurrentTableRowStepPlanGuid() {
      if (this.activeStepPlanGuid) {
        if (this.currentTableRows.length > 0) {
          this.currentTableRows.forEach(item => {
            item.StepPlanGuid = this.activeStepPlanGuid;
          });
          if (this.saveHandler) {
            this.saveHandler(this.currentTableRows);
          }
          this.$emit('update:visible', false);
        } else {
          httpPost('shareStock/BatchChangePriceSetAsyncAsync', {
            NewStepPlanGuid: this.activeStepPlanGuid,
            Model: this.Model,
            Brand: this.Brand,
            StandardPriceStart: this.StandardPriceStart,
            StandardPriceEnd: this.StandardPriceEnd,
            StepPlanGuid: this.StepPlanGuid,
            IsUnUsual: this.IsUnUsual,
            TaxRate: this.getIsInvoice ? this.getIsInvoice() : null
          }).then(res => {
            if (res.Code === 0) {
              this.$emit('update:visible', false);
              this.$alert('设置成功！将在8分钟内完成更新。', '提示', {
                confirmButtonText: '确定'
              });
            } else {
              this.$erroMess(res.Message);
            }
          });
        }
      } else {
        this.$erroMess('请选择阶梯价方案');
      }
    },
    changePricing() {
      this.store.commit('setRoute', { name: 'PricingStrategy', params: {} });
    }
  }
};
</script>
<style lang="scss">
.c-SelectPricing {
  .c-price-card-box {
    height: 280px;
    overflow-x: auto;
    overflow-y: hidden;
    padding-top: 10px;
    box-sizing: border-box;
  }
  .c-PriceCard {
    margin-right: 20px;
    width: 180px;
    height: 247px;
    outline: none;
    .c-PriceCard-body .list-body {
      height: 150px;
    }
    &.active {
      background: url('./imgs/plan_pre.png');
      background-size: 100% 100%;
    }
  }
  .fml {
    margin-left: 10px;
  }
  .fmt {
    margin-top: 15px;
  }
}
</style>
